import { useState } from 'react';
import { Button, Callout, Card, Field, TextInput, useToast } from '@api-hub/ui';
import { PageHeader } from '../components/Layout';
import { api, describeError } from '../lib/api';

export function ChangePasswordPage() {
  const toast = useToast();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [repeat, setRepeat] = useState('');
  const [busy, setBusy] = useState(false);

  const mismatch = repeat.length > 0 && repeat !== newPassword;

  return (
    <>
      <PageHeader
        title="Zmiana hasła"
        description="Zmiana hasła unieważnia wszystkie pozostałe sesje tego konta."
      />
      <Card>
        <Callout>
          Wymagania: minimum 9 znaków oraz trzy z czterech grup — małe litery, wielkie litery,
          cyfry, znaki specjalne.
        </Callout>
        <Field label="Bieżące hasło">
          {(id) => (
            <TextInput
              id={id}
              type="password"
              autoComplete="current-password"
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
            />
          )}
        </Field>
        <Field label="Nowe hasło">
          {(id) => (
            <TextInput
              id={id}
              type="password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
            />
          )}
        </Field>
        <Field label="Powtórz nowe hasło" error={mismatch ? 'Hasła się nie zgadzają.' : undefined}>
          {(id) => (
            <TextInput
              id={id}
              type="password"
              autoComplete="new-password"
              aria-invalid={mismatch}
              value={repeat}
              onChange={(event) => setRepeat(event.target.value)}
            />
          )}
        </Field>
        <Button
          variant="primary"
          disabled={busy || mismatch || newPassword.length < 12 || currentPassword.length === 0}
          onClick={async () => {
            setBusy(true);
            try {
              await api.post('/api/admin/auth/change-password', { currentPassword, newPassword });
              toast.success('Hasło zmienione', 'Pozostałe sesje zostały zakończone.');
              setCurrentPassword('');
              setNewPassword('');
              setRepeat('');
            } catch (error) {
              const described = describeError(error);
              toast.error(described.title, described.body);
            } finally {
              setBusy(false);
            }
          }}
        >
          {busy ? 'Zapisuję…' : 'Zmień hasło'}
        </Button>
      </Card>
    </>
  );
}
